/* eslint-disable jsx-quotes */
import React from 'react';
export default class SelectTestPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { typeTest, tests, value, name, onChange } = this.props;
        return (
            <div key={typeTest.id} className="inline-form-row">
                <label>Provas de {typeTest.title}:</label>
                <select
                    onChange={({ target }) => {
                        onChange(target.value, typeTest.id);
                    }}
                    name={name}
                    value={value}
                >
                    <option value="">Sem testes</option>
                    {tests &&
                        tests[typeTest.id].map((test, indexTest) => (
                            <option key={indexTest} value={test.id}>
                                {`${test.label}${
                                    test.status === 'INCOMPLETE'
                                        ? ' (incompleto)'
                                        : ''
                                }`}
                            </option>
                        ))}
                </select>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectTest/SelectTestPresentation.js